import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ViewChild, ViewChildren, AfterViewInit, AfterViewChecked, Output } from '@angular/core';
import { MatListOption, MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { RouterService } from 'src/app/services/router/router.service';
import { MaintenanceMenuService } from './maintenance-menu.service';

@Component({
  selector: 'app-maintenance-menu',
  templateUrl: './maintenance-menu.component.html',
  styleUrls: ['./maintenance-menu.component.scss']
})
export class MaintenanceMenuComponent implements OnInit {
  public menuItems = [
    // 商品マスタ
    [
      { title: '新商品登録', path: 'register-new-goods', initSelected: false },
      { title: '商品アンマッチ解消', path: 'solve-unmatched-goods', initSelected: false },
      { title: '商品登録・更新', path: 'register-goods', initSelected: false },
      { title: '変換表更新', path: 'convert-goods-attribute', initSelected: false }
    ],
    // カレンダマスタ
    [
      { title: 'カレンダ設定', path: 'configure-chain-calendar', initSelected: false },
      { title: 'カレンダ更新', path: 'update-calendar', initSelected: false }
    ],
    // 店舗マスタ
    [
      { title: '店舗アンマッチ解消', path: 'solve-unmatched-stores', initSelected: false },
      { title: '店舗更新', path: 'update-stores', initSelected: false }
    ],
    // チェーンマスタ
    [
      { title: 'チェーン更新', path: 'update-chains', initSelected: false },
    ],
    // 権限マスタ
    [
      { title: 'チェーンPOS参照権限設定', path: 'set-reference-controls', initSelected: false },
      { title: 'マスタ権限設定', path: 'set-maintenance-controls', initSelected: false }
    ],
  ];

  constructor(
    private routerService: RouterService,
    public maintenanceMenuService: MaintenanceMenuService) {}

  ngOnInit(): void {
    const path = this.routerService.previousPage;
    path.subscribe(x => {
      this.menuItems.forEach(item => {
        const menu = item.find(m => m.path === x);
        if (!menu) {
          return;
        }
        menu.initSelected = true;
      });
    });
  }

  public changedMenuItem(path: string) {
    this.routerService.navigateByUrl(path);
  }

  public closeMenu() {
    this.maintenanceMenuService.closeMenu();
  }
}
